import { useDispatch } from 'react-redux';
import { useEffect, useMemo, useState } from 'react';
import { fetchTransformDoc } from 'js/actions';
import { ReusableTransformDocumentationType } from 'src/@types';

type Response = ReusableTransformDocumentationType | null;

export function useGetTransformDocumentation(
  transformID: number,
  deps: React.DependencyList = [],
): Response {
  const dispatch = useDispatch<any>();
  const [state, setState] = useState(null);

  if (!transformID) return null;

  const fetchData = async () => {
    const response = await dispatch(fetchTransformDoc(transformID));

    if (!response?.entities?.docs) {
      return null;
    }

    return Object.values(response?.entities?.docs)[0];
  };

  useEffect(() => {
    fetchData().then(setState);
  }, deps);

  return useMemo(() => state, [deps]);
}
